/* eslint-disable react-hooks/rules-of-hooks */

export const formatDate = (date: string) => {
  return new Date(date).toISOString().split('T')[0];
};
export const formatPrice = (
  price: number,
  locale: string,
  currency: string,
  minDigits: number,
  maxDigits: number
) => {
  return Number(price).toLocaleString(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: minDigits,
    maximumFractionDigits: maxDigits,
  });
};

export const formatPriceSimple = (
  price: number,
  locale: string = 'es-MX',
  minDigits: number = 2,
  maxDigits: number = 2
): string => {
  return Number(price).toLocaleString(locale, {
    minimumFractionDigits: minDigits,
    maximumFractionDigits: maxDigits,
    useGrouping: true,
  });
};

export const formatPriceSinDecimal = (
  price: number,
  locale: string = 'es-MX',
  minDigits: number = 0,
  maxDigits: number = 0
): string => {
  return Number(price).toLocaleString(locale, {
    minimumFractionDigits: minDigits,
    maximumFractionDigits: maxDigits,
    useGrouping: true,
  });
};

export const formatPriceMejorado = (
  price: number,
  locale: string,
  currency: string
) => {
  // Si tiene decimales (no es entero), muestra 2; si es entero, muestra 0
  const hasDecimals = price % 1 !== 0;

  return Number(price).toLocaleString(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: hasDecimals ? 2 : 0,
  });
};

// Función para formatear números a formato de moneda
export function formatNumberDecimal(num: number): string {
  const [integer, decimal] = num.toFixed(2).split('.');

  const formattedInt = Number(integer).toLocaleString();

  if (decimal === '00') {
    return formattedInt;
  } else {
    return `${formattedInt}.${decimal}`;
  }
}

export const maskPhoneNumber = (inputPhoneNumber: string): string => {
  const numericValue = inputPhoneNumber.replace(/[^\d]/g, '');
  let maskedValue = '';
  for (let i = 0; i < numericValue.length && i < 10; i++) {
    if (i === 0) maskedValue += `${numericValue[i]}`;
    else if (i === 2) maskedValue += ` ${numericValue[i]}`;
    else if (i === 6) maskedValue += ` ${numericValue[i]}`;
    else maskedValue += numericValue[i];
  }
  return maskedValue;
};
export const cleanPhoneNumber = (phoneNumber: string): string => {
  const phone = phoneNumber.replace(/\D/g, '');
  return phone;
};

// Función para calcular dias entre fechas

export const countDaysBetweenDates = (
  dateInit: string,
  dateEnd: string
): number => {
  const startDate = new Date(dateInit);
  const endDate = new Date(dateEnd);

  const differenceInMilliseconds = endDate.getTime() - startDate.getTime();

  const differenceInDays = Math.floor(
    differenceInMilliseconds / (1000 * 3600 * 24)
  );

  return differenceInDays;
};

// Función para calcular porcentaje
/**
 * Calcular porcentaje disponible
 * @param {number} total - Valor en decimales a formatear .
 * @param {number} consumed - cantidad de decimales a mostrar 2 y 4.
 * @returns {number} numero formateado
 */
export const calculatePercentageAvailable = (
  total: number,
  consumed: number
): number => {
  if (total === 0) {
    return 0;
  }
  const available = total - consumed;
  const percentageAvailable = (available / total) * 100;
  return parseFloat(percentageAvailable.toFixed(2));
};

export const calculatePercentage = (total: number, part: number): number => {
  if (total === 0) {
    return 0;
  }
  const percentage = (part / total) * 100;
  return percentage;
};

export const calculateRemainingPercentage = (
  total: number,
  part: number
): number => {
  if (total === 0) {
    return 0;
  }
  const percentageUsed = (part / total) * 100;
  const percentageRemaining = 100 - percentageUsed; // Lo que queda del 100%
  return percentageRemaining;
};

export const formatNumber = (num: number) => {
  return Number.isInteger(num) ? num : num.toFixed(2);
};

export const formatDateMonthGuinMedio = (dateString: string) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
};

export const formatDateString = (dateString: string) => {
  const [year, month, day] = dateString.split('-');
  return `${day}/${month}/${year}`;
};

export const formatDateMonth = (dateString: string) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const formatDateCompleta = (dateString: string): string => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const monthNames = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  return `${day} de ${month} ${year}`;
};

export const formatTime = (dateString: string) => {
  const date = new Date(dateString);
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const period = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours ? hours : 12;

  return `${String(hours).padStart(2, '0')}:${minutes} ${period}`;
};

export const formatFullTime = (dateString: string) => {
  const date = new Date(dateString);
  const hours = String(date.getHours()).padStart(2, '0'); // 24 horas
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${hours}:${minutes}`;
};

// formato de telefono
export const formatPhoneNumber = (telefono: number) => {
  const cleaned = ('' + telefono).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{2})(\d{4})(\d{4})$/);

  if (match) {
    return `${match[1]} ${match[2]} ${match[3]}`;
  }

  return null;
};
// años para tarjeta
export const getYearOptions = (): { value: number; label: number }[] => {
  const currentYear = new Date().getFullYear();
  const yearOptions = [];

  for (let i = 0; i <= 6; i++) {
    const year = currentYear + i;
    yearOptions.push({ value: year, label: year });
  }

  return yearOptions;
};

export const formatearFecha = (fechaIso: string) => {
  const meses = [
    'Ene',
    'Feb',
    'Mar',
    'Abr',
    'May',
    'Jun',
    'Jul',
    'Ago',
    'Sep',
    'Oct',
    'Nov',
    'Dic',
  ];
  const fecha = new Date(fechaIso);
  const dia = fecha.getUTCDate();
  const mes = meses[fecha.getUTCMonth()];
  return `${dia} ${mes}`;
};

export const formatToYMD = (dateString: string) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const formatToDayMonth = (dateString: string) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');

  const monthFormatter = new Intl.DateTimeFormat('es-MX', { month: 'short' });
  const month = monthFormatter.format(date).toUpperCase();

  return `${day} ${month}`;
};

export const formatWithCommas = (value: number) => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: value % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(value);
};

function countDaysFromVigenciaString(vigencia: string): number {
  const regex = /Del (\d{2}\/\d{2}\/\d{4}) al (\d{2}\/\d{2}\/\d{4})/;
  const match = vigencia.match(regex);

  if (!match) return 0;

  const [_, startStr, endStr] = match;

  const [startDay, startMonth, startYear] = startStr.split('/');
  const [endDay, endMonth, endYear] = endStr.split('/');

  const start = new Date(`${startYear}-${startMonth}-${startDay}`);
  const end = new Date(`${endYear}-${endMonth}-${endDay}`);

  const diffTime = Math.abs(end.getTime() - start.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // Incluye ambos días

  return diffDays;
}

export const getVigenciaLabel = (vigencia: string): string => {
  const dias = countDaysFromVigenciaString(vigencia);

  let tipo = '';

  if (dias >= 365) {
    tipo = 'Anual';
  } else if (dias <= 7) {
    tipo = 'Semanal';
  } else if (dias <= 15) {
    tipo = 'Quincenal';
  } else if (dias <= 31) {
    tipo = 'Mensual';
  } else {
    tipo = 'Extendida';
  }

  return `${tipo} (${dias} días de vigencia)`;
};

// <-------------------- Obtener fechas --------------------->

// Hoy
export const getToday = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const end = new Date();
  end.setHours(23, 59, 59, 999);
  return { start: today, end };
};

// Ayer
export const getYesterday = () => {
  const start = new Date();
  start.setDate(start.getDate() - 1);
  start.setHours(0, 0, 0, 0);

  const end = new Date();
  end.setDate(end.getDate() - 1);
  end.setHours(23, 59, 59, 999);

  return { start, end };
};

// Esta semana (desde lunes hasta hoy)
export const getThisWeek = () => {
  const now = new Date();
  const day = now.getDay(); // domingo: 0, lunes: 1 ...
  const diffToMonday = day === 0 ? 6 : day - 1;

  const start = new Date();
  start.setDate(now.getDate() - diffToMonday);
  start.setHours(0, 0, 0, 0);

  const end = new Date(); // hoy
  end.setHours(23, 59, 59, 999);

  return { start, end };
};

// Últimos 15 días
export const getLast15Days = () => {
  const start = new Date();
  start.setDate(start.getDate() - 15);
  start.setHours(0, 0, 0, 0);

  const end = new Date();
  end.setHours(23, 59, 59, 999);

  return { start, end };
};

// Este mes (desde el 1 hasta hoy)
export const getThisMonth = () => {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), 1); // primer día del mes
  start.setHours(0, 0, 0, 0);

  const end = new Date(); // hoy
  end.setHours(23, 59, 59, 999);

  return { start, end };
};

// Mes pasado (del 1 al último día)
export const getLastMonth = () => {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  start.setHours(0, 0, 0, 0);

  const end = new Date(now.getFullYear(), now.getMonth(), 0);
  end.setHours(23, 59, 59, 999);

  return { start, end };
};

// <-------------------- Obtener fechas Fin --------------------->
